/* Header */

// Ensure that the mega menu is not loaded twice on the page and is moved to the appropriate location during breakpoint change
$(window).resize(function(){
    moveNavigation();
});

$(document).ready(function(){
  moveNavigation();

  $("#mega-toggle-block-1").remove();
});

function moveNavigation(){
   console.log('resize check for Header');
  if($(window).width() < 1024) {
      //Mobile
     console.log("MOBILE");
      $("#wexMobileNavigation").append( $("#mega-menu-wrap-main-nav") );
      $("#wexMobileNavigation").append( $("#mega-menu-wrap-wex-top-nav") );
  } else {
      //Desktop
     console.log("DESKTOP");
      $("#wexDesktopTopNav").append( $("#mega-menu-wrap-wex-top-nav") );
      $("#wexDesktopMainNav").append( $("#mega-menu-wrap-main-nav") );
  }
}